import { Handle, Position } from '@xyflow/react';
import { CButton, CFormInput } from '@coreui/react';
import { useState, useEffect, useRef, useCallback } from 'react';
import {
  DndContext,
  closestCenter,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { SortableItem } from "@webkit/components/typescript/SortableItem";
import { Modal } from 'react-bootstrap';
import { t } from 'i18next';
import AccomodationService from '@services/accomodation.service';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSpinner } from '@webkit/components/typescript/SpinnerContext';
import { Weight, X } from 'lucide-react'; // icona per la X di eliminazione card 
import { getToastStore } from "@utils/ToastStore";
import { successToast } from '@webkit/functions/utils';

const AccomodationNode = ({ id, data }) => {
  const ctxToast = getToastStore();
  const [title, setTitle] = useState('');
  const [showAlbumModal, setShowAlbumModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { galleryImages, setGalleryImages, galleryPreviews, setGalleryPreviews } = data;
  const fileInputsRef = useRef([]);
  const { showSpinner, hideSpinner } = useSpinner();

  //costanti per il salvataggio a livello locale delle immagini
  const [localImages, setLocalImages] = useState(galleryImages);
  const [localPreviews, setLocalPreviews] = useState(galleryPreviews);

  const [idAccomodation, setIdAccomodation] = useState('');


  useEffect(() => {
    setIdAccomodation(location.pathname.split('/').at(-1));
    setTitle(data.title);
  }, [data.address, data.title]);

  useEffect(() => {

    setLocalPreviews(data.galleryPreviews);
    setLocalImages(data.galleryImages || Array(data.galleryPreviews.length).fill(null));

  }, [data.galleryPreviews, data.galleryImages]);

  const handleGalleryChange = (e, index) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const maxSize = 5 * 1024 * 1024;
    const file = e.target.files[0];

    if (file.type !== "image/jpeg" && file.type !== "image/png" && file.type !== "image/jpg") {
      if (ctxToast) {
        ctxToast.setToastMsg(t("error.invalid_image_format"));
        ctxToast.setSeeToast(true);
        ctxToast.setErrorToast(true);
      }
      e.target.value = "";
      return;
    }
    if (file.size > maxSize) {
      if (ctxToast) {
        ctxToast.setToastMsg(t("error.too_large"));
        ctxToast.setSeeToast(true);
        ctxToast.setErrorToast(true);
      }
      e.target.value = "";
      return;
    }

    // Copia le immagini e preview esistenti
    const newImages = [...localImages];
    const newPreviews = [...localPreviews];

    // Salva il file originale (per l'upload)
    newImages[index] = file;
    setLocalImages(newImages);

    // Converte il file in base64 per la preview
    const reader = new FileReader();
    reader.onloadend = () => {
      newPreviews[index] = reader.result; // Base64 string
      setLocalPreviews(newPreviews);
    };
    reader.readAsDataURL(file); // Converte il file
  };

  const handleRemoveImage = (index, e) => {
    e.stopPropagation();
    const newImages = [...localImages];
    const newPreviews = [...localPreviews];

    if (newPreviews[index]) {
      URL.revokeObjectURL(newPreviews[index]);
    }
    newImages[index] = null;
    newPreviews[index] = null;

    setLocalImages(newImages);
    setLocalPreviews(newPreviews);

    if (fileInputsRef.current[index]) {
      fileInputsRef.current[index].value = "";
    }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = Number(active.id);
    const newIndex = Number(over.id);

    setLocalImages((items) => arrayMove(items, oldIndex, newIndex));
    setLocalPreviews((items) => arrayMove(items, oldIndex, newIndex));
  };

  const handleSubmitAlbum = async () => {
    let formData = new FormData();

    try {
      showSpinner();
      localImages.filter(Boolean).forEach(file => formData.append('photos', file));
      setIdAccomodation(location.pathname.split('/').at(-1));
      setGalleryPreviews(localPreviews);
      setGalleryImages(localImages);
      await AccomodationService.updatePhotos(formData, idAccomodation);
      successToast(ctxToast, t("success.updated"));
    } catch (error) {
      console.error('Errore nel caricamento immagini');
    } finally {
      hideSpinner();
      setShowAlbumModal(false);
    }
  };

  //funzione per click sulla X
  const handleDeleteClick = useCallback((e) => {
    e.stopPropagation();
    if (data.onDelete) data.onDelete(id);
  }, [data, id]);

  const buttonStyle = {
    backgroundColor: 'var(--primary-color)',
    paddingVertical: 15,
    paddingHorizontal: 50,
    borderRadius: 25,
    alignItems: 'center',
    marginBottom: 10,
    fontWeight:'500'
  };

  return (
    <>
      <div
        style={{
          backgroundColor: '#1e1e1e',
          border: '3px solid #2d72f3ff',
          borderRadius: '20px',
          width: '240px',
          color: 'white',
          padding: '12px',
          boxShadow: '0 0 30px #2d72f3ff',
          position: 'relative', // serve per posizionare la X
        }}
      >
        {/* pulsante X per eliminare */}
        <button
          onClick={handleDeleteClick}
          style={{
            position: 'absolute',
            top: '2px',
            right: '2px',
            background: 'transparent',
            border: 'none',
            color: '#4A90E2',
            cursor: 'pointer',
          }}
          title="Elimina nodo"
        >
          <X size={13} />
        </button>

        {/* Titolo */}
        <h4
          style={{
            fontSize: '14px',
            fontWeight: '700',
            marginBottom: '12px',
            borderBottom: '1px solid #4A90E2',
            paddingBottom: '5px',
            color: '#fff',
            marginTop: '12px'
          }}
        >
          {data.title}
        </h4>
        {/* Pulsanti */}

        {/* PULSANTE CREA CARD */}
        <CButton
          className='text-uppercase nodrag mb-2'
          style={{
            backgroundColor: '#2d72f3ff',
            borderRadius: '25px',
            border: 'none',
            width: '100%',
            color: '#fff',
            fontWeight: '600'

          }}
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            navigate('create-cardinfo');
          }}
        >
          {t('button.create_card')}
        </CButton>

        {/* PULSANTE MODIFICA ACCOMODATION */}
        <CButton
          className='text-uppercase nodrag mb-2'
          style={{
            backgroundColor: '#2d72f3ff',
            borderRadius: '25px',
            border: 'none',
            width: '100%',
            color: '#fff',
            fontWeight: '600',
          }}
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/${idAccomodation}/edit-app`)
          }}
        >
          {t('button.edit')}
        </CButton>

        {/* PULSANTE ALBUM */}
        <CButton
          className='text-uppercase nodrag mb-2'
          style={{
            backgroundColor: '#2d72f3ff',
            borderRadius: '25px',
            border: 'none',
            width: '100%',
            color: '#fff',
            fontWeight: '600',
          }}
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            setShowAlbumModal(true);
          }}
        >
          {t('button.view_album')}
        </CButton>


        {/* Handle per connessione */}
        <Handle type="source" position={Position.Right} />
      </div>

      {/* Modale album caricamento immagini */}
      <Modal
        size="lg"
        show={showAlbumModal}
        //onHide={() => setShowAlbumModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('title.album')}</Modal.Title>
        </Modal.Header>
        <Modal.Body onClick={(e) => e.stopPropagation()}>
          <label className="form-label">{t('label.gallery_images')} (max 10)</label>
          <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext
              items={galleryImages.map((_, i) => i.toString())}
              strategy={rectSortingStrategy}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(5, 1fr)",
                  gap: "10px",
                }}
              >
                {localImages.map((file, index) => (
                  <SortableItem
                    key={index}
                    id={index.toString()}
                    index={index}
                    preview={localPreviews[index]}
                    onRemove={handleRemoveImage}
                    fileInputsRef={fileInputsRef}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => handleGalleryChange(e, index)}
                  />
                ))}
              </div>
            </SortableContext>
          </DndContext>
        </Modal.Body>
        <Modal.Footer>
          <div
            className="card-footer bg-transparent w-100"
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: "20px" }}
          >
            <CButton
              className="hst-btn-secondary"
              onClick={() => setShowAlbumModal(false)}
            >
              {t('text.go_back')}
            </CButton>
          
            <CButton
              className='text-white text-uppercase px-4'
              style={buttonStyle}
              onClick={handleSubmitAlbum}
            >
              {t('button.save')}
            </CButton>
          </div>
          
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AccomodationNode;
